<div class="row select-row">
    <div class="col-3">
        <div class="select-search-label">
            {{dropdownLabel}}
        </div>
    </div>
    <div class="col-7">
        <select id="selectSearchDropdown" 
            class="form-select"  
            [attr.aria-label]="ariaLabelSelect" 
            [(ngModel)]="searchCategory" 
            (change)="onCategoryChange($event)">
            <option *ngFor="let option of options" [value]="option.value">
                {{ option.label }}
            </option>
        </select>
    </div>
</div>
